"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as a } from "react/jsx-runtime";
import { useTheme as l } from "../../hooks.js";
import { useIsInverseVariant as n } from "../../theme-variant-context.js";
import { vars as t } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: i, size: c = 24 } = _param, e = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const h = n(), o = i !== null && i !== void 0 ? i : h ? t.colors.inverse : t.colors.neutralHigh, { skinName: r } = l();
    return r.match(/^vivo-new/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ a("path", {
            fill: o,
            d: "M3.176 6.857c0 .208.12.49.527.824.403.33 1.02.655 1.836.939 1.626.565 3.91.925 6.461.925 2.55 0 4.835-.36 6.46-.925.816-.284 1.434-.608 1.837-.94.407-.333.526-.615.526-.823s-.12-.49-.526-.824c-.403-.33-1.02-.655-1.836-.938-1.626-.566-3.91-.926-6.461-.926-2.55 0-4.835.36-6.46.926-.816.283-1.434.607-1.837.939-.407.334-.527.615-.527.823M2 6.857c0-.695.407-1.275.953-1.724.55-.452 1.31-.833 2.198-1.142C6.93 3.372 9.353 3 12 3s5.069.372 6.85.991c.887.309 1.647.69 2.197 1.142.546.449.953 1.029.953 1.724v10.13c0 .706-.395 1.304-.942 1.776-.55.473-1.311.873-2.2 1.197C17.074 20.61 14.65 21 12 21s-5.074-.39-6.858-1.04c-.889-.324-1.65-.724-2.2-1.197-.547-.472-.942-1.07-.942-1.776zm18.824 1.896c-.525.378-1.202.701-1.975.97-1.78.62-4.202.991-6.849.991s-5.069-.372-6.85-.991c-.772-.269-1.449-.592-1.974-.97v8.234c0 .241.133.545.537.893.403.347 1.02.686 1.834.983 1.623.59 3.905.968 6.453.968s4.83-.377 6.453-.968c.814-.297 1.43-.636 1.834-.983.404-.348.537-.652.537-.893z"
        })
    })) : r.match(/^o2-new/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ a("path", {
            fill: o,
            d: "M15.833 5.016c1.44 0 2.834.613 3.833 1.68a.706.706 0 0 1-.036 1.003.706.706 0 0 1-1.004-.036 3.8 3.8 0 0 0-2.793-1.226 3.8 3.8 0 0 0-2.793 1.226.715.715 0 0 1-1.003.036A.715.715 0 0 1 12 6.696a5.26 5.26 0 0 1 3.833-1.68m-5.45.73a.71.71 0 0 0 .514-.217 6.8 6.8 0 0 1 4.94-2.112c1.88 0 3.634.75 4.942 2.112a.714.714 0 0 0 1.003.022.714.714 0 0 0 .023-1.003A8.2 8.2 0 0 0 15.842 2 8.2 8.2 0 0 0 9.88 4.548a.71.71 0 0 0 .019 1.003.68.68 0 0 0 .486.196M5.37 17.256c-.686 0-1.24.554-1.24 1.24s.554 1.24 1.24 1.24 1.24-.555 1.24-1.24c0-.686-.554-1.24-1.24-1.24m16.499 1.24a3.374 3.374 0 0 1-3.37 3.37H5.369A3.374 3.374 0 0 1 2 18.494a3.374 3.374 0 0 1 3.37-3.37h9.755V9.802a.71.71 0 0 1 1.417 0v5.323h1.952a3.375 3.375 0 0 1 3.375 3.37m-1.422 0a1.956 1.956 0 0 0-1.953-1.953H5.37a1.956 1.956 0 0 0-1.953 1.952c0 1.077.876 1.953 1.953 1.953h13.129a1.955 1.955 0 0 0 1.948-1.953"
        })
    })) : r.match(/^o2/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ a("path", {
            fill: o,
            d: "M15.833 5.016c1.44 0 2.834.613 3.833 1.68a.706.706 0 0 1-.036 1.003.706.706 0 0 1-1.004-.036 3.8 3.8 0 0 0-2.793-1.226 3.8 3.8 0 0 0-2.793 1.226.715.715 0 0 1-1.003.036A.715.715 0 0 1 12 6.696a5.26 5.26 0 0 1 3.833-1.68m-5.45.73a.71.71 0 0 0 .514-.217 6.8 6.8 0 0 1 4.94-2.112c1.88 0 3.634.75 4.942 2.112a.714.714 0 0 0 1.003.022.714.714 0 0 0 .023-1.003A8.2 8.2 0 0 0 15.842 2 8.2 8.2 0 0 0 9.88 4.548a.71.71 0 0 0 .019 1.003.68.68 0 0 0 .486.196M5.37 17.256c-.686 0-1.24.554-1.24 1.24s.554 1.24 1.24 1.24 1.24-.555 1.24-1.24c0-.686-.554-1.24-1.24-1.24m16.499 1.24a3.374 3.374 0 0 1-3.37 3.37H5.369A3.374 3.374 0 0 1 2 18.494a3.374 3.374 0 0 1 3.37-3.37h9.755V9.802a.71.71 0 0 1 1.417 0v5.323h1.952a3.375 3.375 0 0 1 3.375 3.37m-1.422 0a1.956 1.956 0 0 0-1.953-1.953H5.37a1.956 1.956 0 0 0-1.953 1.952c0 1.077.876 1.953 1.953 1.953h13.129a1.955 1.955 0 0 0 1.948-1.953"
        })
    })) : /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ a("path", {
            fill: o,
            d: "M13.258 6.91c-.025-2.305-1.518-3.683-1.535-3.697a.604.604 0 0 1-.044-.854l.002-.003a.62.62 0 0 1 .869-.045c.078.07 1.907 1.731 1.938 4.569.006.098.104 2.89-1.913 4.672a.623.623 0 0 1-.868-.048.606.606 0 0 1 .042-.854l.003-.002.002-.004c1.588-1.403 1.507-3.708 1.504-3.734m8.583 10.33c0-.94-.252-1.677-.745-2.184-.515-.53-1.277-.795-2.266-.795H8.085V6.927a.615.615 0 0 0-.617-.61.613.613 0 0 0-.616.61v7.33H5.17c-.992 0-1.754.267-2.27.796-.495.51-.744 1.244-.744 2.185v1.622c0 .941.25 1.678.745 2.188.515.529 1.277.795 2.269.795h13.658c.992 0 1.753-.266 2.269-.795.493-.507.745-1.244.745-2.185zm-1.233 1.62c.003.616-.134 1.067-.397 1.339q-.414.422-1.381.423H5.169c-.644 0-1.107-.143-1.381-.423-.266-.272-.4-.723-.4-1.339v-1.622c0-.616.134-1.067.4-1.339.274-.28.737-.423 1.38-.423h13.659c.641 0 1.106.143 1.381.423.266.272.4.723.4 1.34zM5.95 18.151c0-.518-.305-.759-.776-.759-.47 0-.773.241-.776.762 0 .25.07.434.197.56.137.135.336.196.58.196s.445-.064.58-.198c.125-.127.195-.311.195-.56m2.824 0c0-.518-.305-.759-.776-.759-.47 0-.776.241-.776.76 0 .249.07.433.196.56.137.134.336.198.58.198.246 0 .445-.064.58-.198.126-.127.196-.311.196-.56m1-13.397c.011.008.88.82.896 2.179v.002c.001.056.025 1.392-.874 2.183l-.005.005a.604.604 0 0 0-.045.855.62.62 0 0 0 .868.05c1.356-1.196 1.289-3.067 1.286-3.123-.023-1.894-1.25-3.009-1.303-3.056a.62.62 0 0 0-.874.053.603.603 0 0 0 .05.852"
        })
    }));
}, p = s;
export { p as default };
